/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */

import type {
  DashboardFilter,
  ReadDashboardsApiResponse,
  ReadFiltersApiResponse,
  ReadInstrumentsApiResponse,
} from 'lib-analytics-types';
import kebabCase from 'lodash/kebabCase';
import { Writable } from 'ts-essentials';

function transformFilter(filter: Writable<DashboardFilter>) {
  filter.label = filter.label ?? filter.field;
  filter.values = filter.values.filter((item) => item.label);
}

/**
 * Returns the transformed dashboards response.
 *
 * @param response The raw response from the dashboards endpoint.
 */
export function transformReadDashboardsResponse(
  response: any,
): ReadDashboardsApiResponse {
  response.data.dashboards.forEach((dashboard) => {
    dashboard.slug = dashboard.slug ?? kebabCase(dashboard.title);
    dashboard.icon = dashboard.icon ?? 'chart-bar';
    dashboard.filters.forEach(transformFilter);
    transformFilter(dashboard.context);
  });

  return response;
}

/**
 * Returns the transformed filters response.
 *
 * @param response The raw response from the filters endpoint.
 */
export function transformReadFiltersResponse(
  response: any,
): ReadFiltersApiResponse {
  response.data.filters.forEach(transformFilter);
  return response;
}

/**
 * Returns the transformed instruments response.
 *
 * @param response The raw response from the instruments endpoint.
 */
export function transformReadInstrumentsResponse(
  response: any,
  meta?: any,
): ReadInstrumentsApiResponse {
  response.meta = response.meta ?? {};
  response.meta.request_id = meta?.response?.headers?.get('X-Dixa-Rid');

  return response;
}
